// extracted by mini-css-extract-plugin
export default {"visible":"LazyContainer_visible__fl-vv","fadeIn":"LazyContainer_fadeIn__hkM7c","sr-only":"LazyContainer_sr-only__wZlPG"};